/* eslint-disable no-param-reassign */
export default (state, { payload: { accounts, accountId, userId, userName, email, role } }) => {
  state.accounts = accounts ?? [];
  state.currentAccountId = accountId ? Number(accountId) : null;
  state.userId = userId ? Number(userId) : null;
  state.userName = userName ?? null;
  state.email = email ?? null;
  state.role = role ?? null;
};
